import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { usePeriscopeActions } from '@hooks';
import React, { useCallback } from 'react';

export interface PeriscopeCloseProps {
	index: number;
}

export const PeriscopeClose: React.FC<PeriscopeCloseProps> = ({ index }) => {
	const { closePeriscope } = usePeriscopeActions();

	const handleClick = useCallback(() => {
		closePeriscope(index);
	}, [ closePeriscope, index ]);

	return (
		<div className='periscope-close'>
			<Button
				icon={ <CloseOutlined /> }
				onClick={ handleClick }
				type='link' />
		</div>
	);
};
